import React from "react";

function Cuernos() {
  return (
    <g>
      <path
        d="M347.848 23.829c3.687-3.493 3.59-9.024 2.523-13.682-3.105 3.687-5.24 7.86-8.248 11.547 1.551 1.456 3.493 3.105 5.725 2.135zM319.999 20.53c-1.359-1.068-2.815-2.038-4.173-3.105.097 1.65.193 3.202.387 4.851L320 20.53z"
        fill="#fff"
      />
    </g>
  );
}

export default Cuernos;
